








import { Component, Watch } from 'vue-property-decorator'
import { find, get, includes, join, toNumber } from 'lodash'
// import CommonPage from './common/common.page.vue'
// import commonGrayScale from './common/commonGrayScale'

// import SpecialComponent from './special/special.page.vue'

//import { specialCategory } from '@constant/index'

import { SuperMixin } from './category.mixin'
import { divideNum } from '@utils/index'

import { AsyncStatus, NAMEBYCATEGORY } from '@constant/index'

import { namespace } from 'vuex-class'
const categoryModule = namespace('category')

@Component({
  components: {
    // SpecialComponent,
    CommonPage: () => import('./common/common.page.vue'),
    CommonGrayScale: () => import('./commonGrayScale/common.page.vue'),
  },
})
export default class CategoryList extends SuperMixin {
  isSpecial = false
  grayscaleStatus = AsyncStatus.unDef //  未请求 非灰度 灰度
  HAS = AsyncStatus.HAS
  NO = AsyncStatus.NO
  @categoryModule.Action getCategorylist!: (categoryIds: string[] | undefined) => Promise<any>
  @categoryModule.State categoryList!: any
  @categoryModule.Action getGrayscale!: () => Promise<any>

  // $track(){
  //   return {
  //     $view: ()=>{
  //       this.$tracker('121012621')({pindaoname:this.title})
  //     }
  //   }
  // }

  // get isGrayScale() {
  //   return this.categoryIds && includes(this.grayscale, this.categoryIds.join(','))
  // }
  // get grayscaleStatus(){
  //   return this.isGrayScale
  // }
  async setTitle() {
    let result = get(NAMEBYCATEGORY, `${divideNum(this.categoryId)}`) || get(NAMEBYCATEGORY, `${this.categoryId}`)
    const list = await this.getCategorylist(this.categoryIds)
    const category = find(list, (item: any) => item.value == this.categoryId)
    result = result || (result = category ? category.text : '')
    this.$setTitle(result)
    this.$tracker('026', '121012621')({ pindaoname: result })
  }

  async created() {
    //this.isSpecial = includes(specialCategory, this.categoryId)
    this.setTitle()
    const response = await this.getGrayscale()
    const categoryIdsStr = join(this.categoryIds, ',')
    this.grayscaleStatus = includes(response, categoryIdsStr) ? AsyncStatus.HAS : AsyncStatus.NO
  }

  @Watch('$route')
  onChangeRoute(to: any, from: any) {
    if (to && to.name === 'category') {
      this.setTitle()
    }
  }
}
